//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fullNames() {
      return `${this.user?.names} ${this.user?.lastnames}`
    },
    email() {
      return this.user?.email || ''
    },
  },
}
